import { FC } from 'react';
import { LoadingButton, LoadingButtonProps } from '@mui/lab';

const Button: FC<LoadingButtonProps> = ({ ...props }) => {
  return <LoadingButton {...props}  />;
};

export default Button;
